// alterado

import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainerReport,
    GridItem2,
    GridItem3,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDivider,
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    formataPrimeiraReuniaoLabel,
    formataPrimeiraReuniaoTextoDestaque,
    formataPrimeiraReuniaoValor,
    formataPrimeiraReuniaoNumero,
} from '../../../business-components/Formata/Formata'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import formList from '../../../business-rules/List/formList'

import {
    descricaoResumidaPergunta,
    valorPergunta,
    inteiroPergunta,
} from '../form-form/FormServicePerguntas'



const EstudoReportPrimeiraReuniaoInputsSeguroVida = ({ values }) => {

    const linhaFormList = pesquisaList(formList, values.idFormList)

    return (
        <GridItem12>
             <GridContainerReport>
                <GridItem12 align="center">
                    {
                        formataPrimeiraReuniaoTextoDestaque(values.nomeCliente)
                    }
                </GridItem12>
            </GridContainerReport>

            <br/>

            <CardGridDivider/>

            <CardGridDivBody>
                <GridContainerReport>
                    <GridItem3>
                        {
                            formataPrimeiraReuniaoLabel(LABEL.idade)
                        }
                    </GridItem3>
                    <GridItem2>
                        {
                            formataPrimeiraReuniaoNumero(values.idadeCliente)
                        }
                    </GridItem2>
                    <GridItem2 />

                    {linhaFormList.idPatrimonioImobilizado
                        ?
                            <>
                                <GridItem3>
                                    {
                                        formataPrimeiraReuniaoLabel(descricaoResumidaPergunta(linhaFormList,
                                            linhaFormList.idPatrimonioImobilizado))
                                    }
                                </GridItem3>
                                <GridItem2>
                                    {
                                        formataPrimeiraReuniaoValor(valorPergunta(values,
                                            linhaFormList.idPatrimonioImobilizado))
                                    }
                                </GridItem2>
                            </>
                        :
                            ''
                    }
                </GridContainerReport>

                <GridContainerReport>
                    <GridItem3>
                        {
                            formataPrimeiraReuniaoLabel(LABEL.idadeVaiAposentar)
                        }
                    </GridItem3>
                    <GridItem2>
                        {
                            formataPrimeiraReuniaoNumero(values.idadeVaiAposentarCliente)
                        }
                    </GridItem2>
                    <GridItem2 />
                    
                    {linhaFormList.idRecursosFinanceiros
                        ?
                            <>
                                <GridItem3>
                                    {
                                        formataPrimeiraReuniaoLabel(descricaoResumidaPergunta(linhaFormList,
                                            linhaFormList.idRecursosFinanceiros))
                                    }
                                </GridItem3>
                                <GridItem2>
                                    {
                                        formataPrimeiraReuniaoValor(valorPergunta(values,
                                            linhaFormList.idRecursosFinanceiros))
                                    }
                                </GridItem2>
                            </>
                        :
                            ''
                    }
                </GridContainerReport>
                
                <GridContainerReport>
                    <GridItem3>
                        {
                            formataPrimeiraReuniaoLabel(LABEL.idadeExpectativaVida)
                        }
                    </GridItem3>
                    <GridItem2>
                        {
                            formataPrimeiraReuniaoNumero(values.idadeExpectativaVidaCliente)
                        }
                    </GridItem2>
                    <GridItem2 />
                    
                    {linhaFormList.idDiaDia
                        ?
                            <>
                                <GridItem3>
                                    {
                                        formataPrimeiraReuniaoLabel(descricaoResumidaPergunta(linhaFormList,
                                            linhaFormList.idDiaDia))
                                    }
                                </GridItem3>
                                <GridItem2>
                                    {
                                        formataPrimeiraReuniaoValor(valorPergunta(values,
                                            linhaFormList.idDiaDia) * 12)
                                    }
                                </GridItem2>
                            </>
                        :
                            ''
                    }
                </GridContainerReport>
                
                <GridContainerReport>
                    {linhaFormList.idDependentesFinanceiros
                        ?
                            <>
                                <GridItem3>
                                    {
                                        formataPrimeiraReuniaoLabel(descricaoResumidaPergunta(linhaFormList,
                                            linhaFormList.idDependentesFinanceiros))
                                    }
                                </GridItem3>
                                <GridItem2>
                                    {
                                        formataPrimeiraReuniaoNumero(inteiroPergunta(values,
                                            linhaFormList.idDependentesFinanceiros))
                                    }
                                </GridItem2>
                            </>
                        :
                            <>
                                <GridItem3 />
                                <GridItem2 />
                            </>
                    }
                    
                    <GridItem2 />
                    
                    {linhaFormList.idReceitaMensal
                        ?
                            <>
                                <GridItem3>
                                    {
                                        formataPrimeiraReuniaoLabel(descricaoResumidaPergunta(linhaFormList,
                                            linhaFormList.idReceitaMensal))
                                    }
                                </GridItem3>
                                <GridItem2>
                                    {
                                        formataPrimeiraReuniaoValor(valorPergunta(values,
                                            linhaFormList.idReceitaMensal) * 12)
                                    }
                                </GridItem2>
                            </>
                        :
                            ''
                    }
                </GridContainerReport>
            </CardGridDivBody>
        </GridItem12>
    )
}

export default EstudoReportPrimeiraReuniaoInputsSeguroVida